import React, {useState} from 'react'

export default function TestForm(props) {
  const handleUpClick = () =>{
    console.log("Uppercase was clicked");
    let newtext = text.toUpperCase();
    setText(newtext);
  }

  const handleDownClick = () =>{
    console.log("lowercase clicked");
    let newtext = text.toLowerCase();
    setText(newtext);
  }

  const clearclick = () =>{
    let newtext = "";
    setText(newtext);
  }

  const handleOnChange = (event) =>{ 
    console.log("on change");
    setText(event.target.value);
  } 
  
  const copyText = () =>{
    var text = document.getElementById("myBox");
    text.select();
    navigator.clipboard.writeText(text.value)
  }

  const [ text, setText] = useState("");
  return (
    <>
    <div className={`coo bg-${props.mode}`}>
    <div className='container'>
        <h1>{props.heading}</h1>
        <div className="mb-3">
        <textarea className="form-control" value={text} onChange={handleOnChange} placeholder="Leave a comment here" id="myBox" rows="8"></textarea>
        </div>
        <button className="btn btn-primary" onClick={handleUpClick}>Convert to UPPERCASE</button>
        <button className="btn btn-primary mx-2" onClick={handleDownClick}>Convert to lowercase</button>
        <button className="btn btn-primary mx-2" onClick={clearclick}>Clear Text</button>
        <button className="btn btn-primary mx-2" onClick={copyText}>Copy</button>
    </div>
    <div className="container my-5">
        <h1>Your text summary</h1>
        <p>{text.split(" ").length} words , {text.length} characters</p>
        <h2>Preview:</h2>
        <p>{text.length > 0 ? text:"Enter text to preview it here"}</p>
    </div>
    </div>
    </>

  )
}
